import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { AccaBoostRatioPipe } from '../../../../../lib/acca-boost-base/acca-boost-ratio.pipe';
import { RewardTokenType } from '../../../../../lib/tokens-base/token-base.models';
import { IRewardTokenBadge } from '../../models/reward-token-badge.model';

@Component({
    selector: 'bs-reward-used-badge',
    templateUrl: './result-reward-used-badge.component.html',
    styleUrls: ['./result-reward-used-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultRewardUsedBadgeComponent {
    @Input() badge: IRewardTokenBadge;

    readonly RewardTokenType = RewardTokenType;
    accaBoostPercentageTitle: string;
    isEnhancedAccaBoostLayoutEnabled = false;

    constructor(
        private sitecore: Sitecore,
        private accaBoostRatioFormatter: AccaBoostRatioPipe,
        private accaBoostConfig: AccaBoostConfig,
    ) {}

    ngOnInit(): void {
        if (this.accaBoostConfig.isEnhancedLayoutEnabled && this.badge.typeData.tokenType === RewardTokenType.AccaBoost) {
            this.accaBoostPercentageTitle = this.accaBoostRatioFormatter.transform(
                this.badge.typeData.boostedByRatio,
                false,
                this.sitecore.accaBoost.AccaBoostPercentageTitle,
            );
            this.isEnhancedAccaBoostLayoutEnabled = true;
        }
    }

    getBadgeCount(count: number): string {
        return `${count}x`;
    }
}
